// extracted by mini-css-extract-plugin
export default {"inbox":"inbox__pasjk","unreadCount":"unreadCount__a7Rup","manyMessages":"manyMessages__TYWQn"};